import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaCalendarCheck, FaUserMd } from "react-icons/fa";
import CommonNavbar from "./CommonLayout/CommonNavbar";
import CommonFooter from "./CommonLayout/CommonFooter";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "animate.css";
import "../../assets/css/Home2.css";
import HeroImg from "../../assets/img/Home2Img.jpg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Home2Footer.js";
import Home2Footer from "./Home2Footer.js";
import Home2Navbar from "./Home2Navbar.js";
const Home2 = () => {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Simulate data fetching
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <div>
      <Home2Navbar />
      {/* <div className="hero-section d-flex align-items-center text-center">
      <Container>
        {loading ? (
          <>
            <Skeleton height={50} width="60%" className="mb-3" />
            <Skeleton height={20} width="80%" className="mb-4" />
            <Skeleton height={45} width={200} className="mr-3" />
            <Skeleton height={45} width={250} />
          </>
        ) : (
          <>
            <h1 className="hero-title animate__animated animate__fadeInDown">
              Your Trusted Counselling Platform
            </h1>
            <p className="hero-subtitle animate__animated animate__fadeInUp">
              Book appointments with expert Psycho-Oncologist
            </p>
            <div className="hero-buttons mt-4">
              <Link to="/create-account">
                <Button variant="primary" size="lg" className="me-3">
                  <FaCalendarCheck className="me-2" /> Book Appointment
                </Button>
              </Link>
              <Link to="/create-counsellor-account">
                <Button variant="outline-light" size="lg">
                  <FaUserMd className="me-2" /> Register as Counsellor
                </Button>
              </Link>
            </div>
          </>
        )}
      </Container>
      </div> */}

      {/* 🔹 Specialized Mental Support Section */}
      <div className="support-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              <h1
                className=" fw-bold mb-3"
                style={{ color: "#080c77", fontWeight: "bolder" }}
              >
                Specialized Mental Support for Cancer Journeys
              </h1>
              <p>
                Connect with psycho-oncologists who understand the unique
                emotional challenges of cancer. For patients, caregivers, and
                healthcare professionals.
              </p>
              <div className="mt-4">
                <Button
                  className="me-3 btn btn-lg book-session-btn"
                  style={{
                    backgroundColor: "#080c77",
                    borderColor: "#080c77",
                    borderRadius: "5px",
                  }}
                >
                  <small>Book a Session</small>
                </Button>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <Button
                  className="me-3 btn btn-lg join-counselor-btn"
                  style={{
                    backgroundColor: "#fcfbfe",
                    borderColor: "#fcfbfe",
                    borderRadius: "5px",
                    color: "#333",
                  }}
                >
                  <small>Join as a Counselor</small>
                </Button>{" "}
              </div>
              <div className="round-container flex justify-center items-center mt-3">
                <div className="round mx-1"></div>
                <div className="round mx-1"></div>
                <div className="round mx-1"></div>
                <div className="round mx-1"></div>
                <label style={{marginLeft: "90px",marginTop: "10px"}} id="round-label">Trusted by&nbsp;
                <b style={{ color: "#de0f3f", fontSize: "20px" }}>
                  2,000+
                </b>
                &nbsp;patients and professionals</label>
              </div>
            </Col>
            <Col md={6}>
              <img
                src={HeroImg}
                alt="Healthcare professionals"
                className="img-fluid rounded"
                style={{ borderRadius: "15px" }}
              />
            </Col>
          </Row>
        </Container>
      </div>
      {/* 🔹 4 Cards section */}
      <section
        className="service-section"
        style={{
          paddingTop: "0px",
          paddingBottom: "40px",
          color: "#212529!important",
        }}
      >
        {" "}
        <br />
        <br />
        <div className="container">
          <h2 style={{ color: "#080c77" }}>Specialized Support for Everyone</h2>
          <p style={{ textAlign: "center", color: "#212529" }}>
            Our platform connects patients, caregivers, and healthcare
            professionals with specialized psycho-oncology support.
          </p>
          <div className="cards-grid">
            {/* Card 1 */}
            <div className="service-card">
              <div className="circle mx-auto mb-1">
                <i
                  className="fas fa-hospital-user"
                  style={{ fontSize: "32px" }}
                ></i>
              </div>
              <h3 style={{ color: "#080c77" }}>For Patients</h3>
              <p style={{ color: "#212529" }}>
                Access specialized mental health support throughout your cancer
                journey from professionals who understand.
              </p>
            </div>

            {/* Card 2 */}
            <div className="service-card">
              <div className="circle mx-auto mb-3">
                <i className="fas fa-users icon"></i>
              </div>
              <h3 style={{ color: "#080c77" }}>For Caregivers</h3>
              <p>
                Find support for the unique challenges you face while caring for
                a loved one with cancer.
              </p>
            </div>

            {/* Card 3 */}
            <div className="service-card">
              <div className="circle mx-auto mb-3">
                <i className="fas fa-briefcase-medical icon"></i>
              </div>
              <h3 style={{ color: "#080c77" }}>For Healthcare Professionals</h3>
              <p>
                Connect with psycho-oncologists for consultation and
                interdisciplinary collaboration.
              </p>
            </div>

            {/* Card 4 */}
            <div className="service-card">
              <div className="circle mx-auto mb-3">
                <i
                  class="fa-solid fa-house-medical-circle-check"
                  style={{ fontSize: "32px" }}
                ></i>{" "}
              </div>
              <h3 style={{ color: "#080c77" }}>Flexible Scheduling</h3>
              <p>
                Book appointments that fit your schedule with our easy-to-use
                booking system.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* 🔹 How It Works Section */}
      <div className="how-it-works py-5">
        <Container>
          <h2 className="text-center fw-bold mb-3" style={{ color: "#080C77" }}>
            How It Works
          </h2>
          <p
            className="text-center text-muted mb-5"
            style={{ color: "#212529t" }}
          >
            Getting the support you need is simple and straightforward. Follow
            these steps to connect with a specialist.
          </p>
          <div className="position-relative d-flex justify-content-between text-center steps-wrapper">
            <div className="line"></div>

            <div className="step">
              <div className="position-absolute start-0 translate-middle-y pop-hover"></div>
              <div className="circle mx-auto mb-3 pop-hover">01</div>
              <h5>Create an Account</h5>
              <p className="text-muted small px-2" style={{fontSize:"15px"}}>
                Sign up as a patient, caregiver, or healthcare professional to
                get started.
              </p>
            </div>

            <div className="step">
              <div className="circle mx-auto mb-3 pop-hover">02</div>
              <h5>Find a Specialist</h5>
              <p className="text-muted small px-2" style={{fontSize:"15px"}}>
                Browse our directory of qualified psycho-oncologists based on
                your specific needs.
              </p>
            </div>

            <div className="step">
              <div className="circle mx-auto mb-3 pop-hover">03</div>
              <h5>Book a Session</h5>
              <p className="text-muted small px-2" style={{fontSize:"15px"}}>
                Choose a convenient time from your specialist's available
                schedule.
              </p>
            </div>

            <div className="step">
              <div className="circle mx-auto mb-3 pop-hover">04</div>
              <h5>Get Support</h5>
              <p className="text-muted small px-2" style={{fontSize:"15px"}}>
                Connect with your specialist through video call or in-person
                appointment.
              </p>
            </div>
          </div>
        </Container>
      </div>

      <section className="testimonials-section">
        <div className="container">
          <h2 className="section-title">What People Are Saying</h2>
          <p className="section-subtitle">
            Hear from patients, caregivers, and healthcare professionals who
            have found support through our platform.
          </p>

          <Swiper
            modules={[Pagination, Autoplay]}
            autoplay={{ delay: 5000 }}
            pagination={{ clickable: true }}
            loop={true}
            className="testimonial-swiper"
          >
            <SwiperSlide>
              <div className="testimonial-card">
                <div className="quote-start">“</div>
                <p className="testimonial-text">
                  As a caregiver, I was forgetting to take care of myself. The
                  guidance I've received through Solace Nexus has helped me
                  maintain my own well-being while supporting my partner.
                </p>
                <div className="quote-end">”</div>
                <div className="testimonial-user">
                  <img
                    src="https://randomuser.me/api/portraits/men/32.jpg"
                    alt="User"
                    className="user-img"
                  />
                  <div>
                    <strong>Michael R.</strong>
                    <div className="user-role">Caregiver</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="quote-start">“</div>
                <p className="testimonial-text">
                  This platform has been an absolute lifesaver for me. The
                  resources are invaluable, and I’ve gained so much insight into
                  how to better manage my health condition.
                </p>
                <div className="quote-end">”</div>
                <div className="testimonial-user">
                  <img
                    src="https://randomuser.me/api/portraits/men/33.jpg"
                    alt="User"
                    className="user-img"
                  />
                  <div>
                    <strong>Anna W.</strong>
                    <div className="user-role">Patient</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <div className="quote-start">“</div>
                <p className="testimonial-text">
                  I recommend Solace Nexus to all my colleagues. It's not only a
                  great resource for patients, but it also provides healthcare
                  professionals like me with tools to support our work.
                </p>
                <div className="quote-end">”</div>
                <div className="testimonial-user">
                  <img
                    src="https://randomuser.me/api/portraits/women/42.jpg"
                    alt="User"
                    className="user-img"
                  />
                  <div>
                    <strong>Dr. Emma K.</strong>
                    <div className="user-role">Healthcare Professional</div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      <br />
      {/* Video section */}
      <div className="container-fluid px-5 py-6">
        <div
          className="hero-section-video-wrapper position-relative text-center"
          style={{
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.4)", // ✨ Shadow added
            border: "none",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              height: "100%",
              backgroundImage: `url(${require("../../assets/img/bg.png")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              maxHeight: "500px",
            }}
          >
            <div
              className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
              style={{ color: "#080c77", padding: "1rem" }}
            >
              <h5 className="hero-title animate__animated animate__fadeInDown">
                Your Trusted Counselling Platform
              </h5>
              <p className="hero-subtitle animate__animated animate__fadeInUp">
                Book appointments with expert Psycho-Oncologists
              </p>
              <div className="hero-buttons mt-3 d-flex flex-row flex-wrap gap-3">
                <Button
                  className="btn btn-md btn-custom btn-book-session-custom"
                  style={{
                    backgroundColor: "#080c77",
                    borderColor: "#080c77",
                  }}
                >
                  Book a Session
                </Button>
                &nbsp;&nbsp; &nbsp;
                <Button
                  className="btn btn-md btn-custom btn-join-counselor-custom"
                  style={{
                    backgroundColor: "#de0f3f",
                    borderColor: "#de0f3f",
                  }}
                >
                  Join as a Counselor
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />

      {/* <CommonFooter /> */}
      <Home2Footer />
    </div>
  );
};

export default Home2;
